import { useState } from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { getRandomMaintenanceMessage, type MaintenanceMessageContext } from '@/services/maintenanceMessages';

export function MaintenanceCompanionMessage({ context }: { context: MaintenanceMessageContext }) {
  const [message] = useState(() => getRandomMaintenanceMessage(context));
  if (!message) return null;

  return (
    <p className="mt-4 flex w-full max-w-[58ch] items-start gap-2.5 text-sm leading-relaxed text-zinc-500 dark:text-white/55">
      <SparklesIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-700/80 dark:text-teal-300/70" aria-hidden="true" />
      <span className="italic">{message}</span>
    </p>
  );
}
